import { Modal } from 'bootstrap';

function getConfirmModalEl() {
    return document.getElementById('confirm-modal');
}

export function initConfirmModal() {
    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-confirm="modal"]');
        if (!trigger) return;

        e.preventDefault();

        const modalEl = getConfirmModalEl();
        if (!modalEl) return;

        const titleEl = modalEl.querySelector('[data-confirm-title]');
        const messageEl = modalEl.querySelector('[data-confirm-message]');
        const submitBtn = modalEl.querySelector('[data-confirm-submit]');

        const title = trigger.getAttribute('data-confirm-title') || 'Confirmation';
        const message = trigger.getAttribute('data-confirm-message') || 'Confirmer l’action ?';
        const confirmText = trigger.getAttribute('data-confirm-confirm-text') || 'Confirmer';

        if (titleEl) titleEl.textContent = title;
        if (messageEl) messageEl.textContent = message;
        if (submitBtn) submitBtn.textContent = confirmText;

        const formSelector = trigger.getAttribute('data-confirm-form');
        const href = trigger.getAttribute('href');
        if (submitBtn) {
            submitBtn.onclick = () => {
                if (formSelector) {
                    document.querySelector(formSelector)?.submit();
                } else if (href) {
                    window.location.href = href;
                }
            };
        }

        Modal.getOrCreateInstance(modalEl).show();
    });
}


